import { executePost } from "../ServiceUtils";

// Should be removed and we should use RTK Query instead

export const saveApplicationAsDraft = async ({ applicationId, applicationTypeId, application }) => {
  return await executePost("/api/application/saveApplicationAsDraft", {
    applicationId,
    applicationTypeId,
    application,
  });
};

export const submitApplication = async ({ applicationId, applicationTypeId, application }) => {
  return await executePost("/api/application/submitApplication", {
    applicationId,
    applicationTypeId,
    application,
  });
};

export const withdrawApplication = async (applicationId) => {
  return await executePost("/api/application/withdrawApplication", applicationId);
};